export function calculatePricingScore(
  ourPrice: number,
  medianPrice: number,
  ourRank: number,
  medianRank: number
): number {
  // Default score
  let pricingScore = 50;

  if (ourRank <= medianRank) {
    // Good rank position - can command higher prices
    if (ourPrice >= 0.9 * medianPrice && ourPrice <= 1.1 * medianPrice) {
      // Optimal pricing
      pricingScore = 80;
    } else if (ourPrice > 1.1 * medianPrice) {
      // Premium pricing
      pricingScore = 70;
    } else {
      // Underpriced
      pricingScore = 60;
    }
  } else {
    // Poor rank position - should adjust pricing
    if (ourPrice > medianPrice) {
      // Overpriced for poor ranking
      pricingScore = 30;
    } else if (ourPrice >= 0.85 * medianPrice) {
      // Reasonable discount for poor ranking
      pricingScore = 50;
    } else {
      // Too heavily discounted
      pricingScore = 40;
    }
  }

  return Math.round(pricingScore);
}

// Calculate rank score based on property's position
export function calculateRankScore(ourRank: number, totalProperties: number): number {
  if (totalProperties <= 0) return 50;

  const rankPercentile = Math.min(100, Math.max(0, ((totalProperties - ourRank) / totalProperties) * 100));
  return Math.round(rankPercentile);
}


